import FadeIn from "react-fade-in";
import ComponentMap from "../../atom/componentmap";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import { useEffect, useRef, useState } from "react";
import { getToken, getXtoneMenu, myXToneLogin } from "../../services/api";
import { Backdrop } from "@mui/material";
import Lottiefy from "../../atom/lottie/lottie";
import { useLocation, useNavigate } from "react-router-dom";
import Notification from "../../atom/Notification";
import { useDispatch } from "react-redux";
import { updateMenu } from "../../toolkit/reducers/myXToneMenuSlice";

function MyXtoneLogin() {
  const [loginRequired, setLoginRequired] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const dispatch = useDispatch();
  const path = useLocation();
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState([
    {
      title: "User ID (extension)",
      name: "user_id",
      value: "",
      layout: 6,
      type: "number",
      minLength: 2,
      maxLength: 7,
      required: true,
      errormessage: "User ID is required",
    },
    {
      title: "PIN",
      name: "pin",
      value: "",
      layout: 4,
      type: "number",
      required: true,
      minLength: 4,
      maxLength: 10,
      errormessage: "PIN is required",
    },
  ]);

  const onLogin = (data: any) => {
    console.log("datadata", data);
    const payload: any = {
      extension: data?.user_id,
      pin: data?.pin,
    };
    setButtonLoader(true);
    myXToneLogin(getToken(), payload).then((result: any) => {
      if (!result.success) {
        let msg = result?.message;
        Notification(
          "Failed",
          msg?.charAt(0).toUpperCase() + msg.slice(1),
          "danger"
        );
        setButtonLoader(false);
      } else {
        // navigate(`/app/myxtone/portal`, { replace: true });
        checkAuthentication();
      }
    });
  };

  const checkAuthentication = () => {
    getXtoneMenu(getToken()).then((result: any) => {
      if (!result.success) {
        navigate(`/app/myxtone/login`, { replace: true });
        // let msg = result?.message;
        // Notification(
        //   "Failed",
        //   msg?.charAt(0).toUpperCase() + msg.slice(1),
        //   "danger"
        // );
        setLoginRequired(true);
        setButtonLoader(false);
      } else {
        setLoginRequired(false);
        setButtonLoader(false);
        navigate(`/app/myxtone/portal`, { replace: true });
        dispatch(updateMenu(result?.data));
      }
    });
  };

  useEffect(() => {
    checkAuthentication();
  }, []);

  return (
    <div
      data-testid="myxtonelogin"
      className="flex justify-center items-center h-[calc(100vh-110px)]"
    >
      {loginRequired && (
        <FadeIn>
          <div className="h-fit max-w-[400px] min-w-[500px] bg-white rounded-lg bg-[#fff]">
            <div className="text-[16px] font-bold px-7 py-4">
              Vaspian X-Tone Login
            </div>
            <div className="mt-4 relative px-5">
              <ComponentMap data={loginData} setData={setLoginData} />
            </div>
            <div className="w-full h-full py-4 flex items-baseline justify-end mt-4 -ml-6">
              <ThemedButton
                children={"Login"}
                icon="custom"
                theme="primary"
                valiData={loginData}
                change={setLoginData}
                loading={buttonLoader}
                click={onLogin}
              />
            </div>
          </div>
        </FadeIn>
      )}
    </div>
  );
}

export default MyXtoneLogin;
